import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_2 = {
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      size: "medium",
      stripe: "",
      data: _ctx.transactions,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  "f-w-700": "",
                  class: "el-icon-money"
                }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "Startup",
          label: "Startup",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("h4", _hoisted_1, _toDisplayString(scope.row.business.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "Talent",
          label: "Talent",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("h4", _hoisted_2, [
              _createTextVNode(_toDisplayString(scope.row.talent.firstName) + " ", 1),
              (scope.row.talent.lastName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.talent.lastName.charAt(0)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Amount",
          align: "right",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.currencySign(scope.row.currency)) + " " + _toDisplayString(scope.row.amount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Status"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: 
              scope.row.status === 'admin'
                ? 'danger'
                : scope.row.status === 'talent'
                ? 'info'
                : 'success'
            ,
              effect: "dark",
              "is-rounded": "",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Created At",
          align: "left",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.$filters.capitalize(_ctx.$moment(scope.row.createdAt).fromNow())), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}